export default __webpack_public_path__ + "static/media/anni-lucky-draw.5fdd90dd.webp";